import { useListPatientZoomMeetings } from "~/providers/hooks/queries/useListPatientZoomMeetings";
import { SessionsTable } from "./SessionsTable";
import { useSessionsTableSorting } from "./useSessionsTableSorting";

interface SessionsProps {
  patientId: string;
}

export const Sessions = ({ patientId }: SessionsProps) => {
  const { sorting, onSortingChange, orderBy, order } =
    useSessionsTableSorting();
  const { data, isFetching } = useListPatientZoomMeetings({
    patientId,
    orderBy,
    order,
  });

  return (
    <div className="flex w-full flex-col gap-6 overflow-y-auto px-14 py-8">
      <SessionsTable
        patientId={patientId}
        sessions={data?.items}
        isFetching={isFetching}
        sorting={sorting}
        onSortingChange={onSortingChange}
      />
    </div>
  );
};
